import { API } from "./api";

function base64ToUint8Array(base64) {
  const pad = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

// On iOS, push only works for the installed Home Screen PWA.
export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
}

async function registerSW() {
  return navigator.serviceWorker.register("/sw.js");
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Push is not supported by this browser");
  const reg = await registerSW();
  const { publicKey } = await fetch(`${API}/push/config`, { credentials: "include" }).then((r) => r.json());
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: base64ToUint8Array(publicKey) });
  }
  const token = localStorage.getItem("gm_token");
  const res = await fetch(`${API}/push/subscription`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(sub.toJSON()),
  });
  if (!res.ok) throw new Error("Could not save subscription");
  return sub;
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const token = localStorage.getItem("gm_token");
    await fetch(`${API}/push/subscription?endpoint=${encodeURIComponent(sub.endpoint)}`, {
      method: "DELETE",
      credentials: "include",
      headers: { Authorization: `Bearer ${token}` },
    });
    await sub.unsubscribe();
  } catch {}
}

export async function pushEnabled() {
  try {
    if (!pushSupported()) return false;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    return !!(await reg.pushManager.getSubscription());
  } catch {
    return false;
  }
}

export function notificationPermission() {
  return "Notification" in window ? Notification.permission : "unsupported";
}
